import InnerComponent from '@Components/Purchase/PurchaseRequests/ViewPurchaseRequest';
import orgContainer from '@Components/AppContainer';

const ViewPurchaseRequest = () => ((orgContainer(InnerComponent)));
export default ViewPurchaseRequest;
